import { useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Shuffle, Loader2, CheckCircle, XCircle, Shield } from "lucide-react";
import { gdprAPI } from "../lib/api";

export default function GdprDelete() {
  const { token } = useParams();
  const [status, setStatus] = useState("confirm"); // confirm, loading, success, error
  const [errorMessage, setErrorMessage] = useState("");

  const handleDelete = async () => {
    setStatus("loading");
    try {
      await gdprAPI.deleteData(token);
      setStatus("success");
    } catch (error) {
      setStatus("error");
      setErrorMessage(error.response?.data?.detail || "Une erreur est survenue");
    }
  };

  return (
    <div className="min-h-screen bg-muted/30 flex items-center justify-center p-6">
      <Card className="bg-card max-w-md w-full">
        <CardContent className="p-8 text-center">
          <Link to="/" className="flex items-center justify-center gap-2 mb-8">
            <div className="w-10 h-10 rounded-xl bg-primary flex items-center justify-center">
              <Shuffle className="w-5 h-5 text-white" />
            </div>
            <span className="text-2xl font-bold text-foreground" style={{ fontFamily: 'Outfit' }}>TIREO</span>
          </Link>

          {status === "confirm" && (
            <>
              <div className="w-16 h-16 rounded-full bg-amber-100 flex items-center justify-center mx-auto mb-6">
                <Shield className="w-10 h-10 text-amber-600" />
              </div>
              <h1 className="text-2xl font-bold text-foreground mb-2" style={{ fontFamily: 'Outfit' }}>
                Suppression de vos données
              </h1>
              <p className="text-muted-foreground mb-6">
                Conformément au RGPD, vous pouvez demander la suppression de toutes vos données personnelles. 
                Cette action est irréversible.
              </p>
              <div className="space-y-3">
                <Button 
                  onClick={handleDelete}
                  className="w-full rounded-full bg-red-600 hover:bg-red-700"
                >
                  Confirmer la suppression
                </Button>
                <Link to="/" className="block">
                  <Button variant="outline" className="w-full rounded-full">
                    Annuler
                  </Button>
                </Link>
              </div>
            </>
          )}

          {status === "loading" && (
            <>
              <Loader2 className="w-16 h-16 text-primary mx-auto mb-6 animate-spin" />
              <h1 className="text-2xl font-bold text-foreground mb-2" style={{ fontFamily: 'Outfit' }}>
                Suppression en cours...
              </h1>
              <p className="text-muted-foreground">
                Veuillez patienter quelques instants.
              </p>
            </>
          )}

          {status === "success" && (
            <>
              <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center mx-auto mb-6">
                <CheckCircle className="w-10 h-10 text-green-600" />
              </div>
              <h1 className="text-2xl font-bold text-foreground mb-2" style={{ fontFamily: 'Outfit' }}>
                Données supprimées
              </h1>
              <p className="text-muted-foreground mb-6">
                Toutes vos données personnelles ont été supprimées conformément au RGPD.
              </p>
              <Link to="/">
                <Button className="rounded-full bg-primary hover:bg-primary/90">
                  Retour à l'accueil
                </Button>
              </Link>
            </>
          )}

          {status === "error" && (
            <>
              <div className="w-16 h-16 rounded-full bg-red-100 flex items-center justify-center mx-auto mb-6">
                <XCircle className="w-10 h-10 text-red-600" />
              </div>
              <h1 className="text-2xl font-bold text-foreground mb-2" style={{ fontFamily: 'Outfit' }}>
                Erreur
              </h1>
              <p className="text-muted-foreground mb-6">
                {errorMessage}
              </p>
              <Link to="/">
                <Button variant="outline" className="rounded-full">
                  Retour à l'accueil
                </Button>
              </Link>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
